import axios from './axios'
import NProgress from 'nprogress'
import { Result } from '@/service/model'

interface Reauest {
  responseType: string
  get<T>(url: string, params?: unknown): Promise<Result<T>>
  post<T>(url: string, params?: any, isArraybuffer?: boolean): Promise<Result<T>>
  upload<T>(url: string, params: unknown): Promise<Result<T>>
  download(url: string): void
}

const request: Reauest = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .get(url, { params })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err)
        })
    })
  },
  post(url, params?: any, isArraybuffer?: boolean) {
    const { switchApi = null, ...restParams } = (params || {}) as Record<string, any>
    const requestBody = Object.keys(restParams).length > 0 ? JSON.stringify(restParams) : undefined
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(switchApi || url, requestBody, { 
          responseType: isArraybuffer ? 'arraybuffer' : 'json'
        })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err)
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(url, file)
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err)
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  },
  responseType: ''
}
export default request
